<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data">
      <template #suffix>
        <b-button
          class="mr-2"
          variant="warning"
          v-auth="`update`"
          @click="refreshRank()"
        >
          重新載入業務聘階
        </b-button>

        <b-button
          class="mr-2"
          variant="success"
          @click="exportSales()"
        >
          匯出業務
        </b-button>

        <b-button
          variant="primary"
          v-auth="`update`"
          @click="openBusinessModal('new')"
        >
          新增
        </b-button>
      </template>
    </bread-crumb>

    <div class="operate">
      <div class="search">
        <b-form-select
          v-model="search.status"
          :options="options.status" />

        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="業務編號"
          v-model="search.number"
          @keyup.enter="getSales(1)" />

        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="業務姓名"
          v-model="search.name"
          @keyup.enter="getSales(1)"/>

        <div class="blur">
          <b-form-input
            placeholder="關鍵字"
            v-model="search.blur"
            @keyup.enter="getSales(1)" />

          <div id="blur_info" class="blur-info">i</div>
        </div>
      </div>

      <div class="btn-area">
        <div class="btn-function">
          <b-button variant="danger" @click="resetSearch()">重置</b-button>

          <b-button variant="success" @click="getSales(1)">搜尋</b-button>
        </div>
      </div>
    </div>

    <b-tooltip
      target="blur_info"
      placement="top"
      title="業務編號、業務姓名、業務身分證" />

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
      :pageData="data.page"
      v-on:result="getSales"
      tableId="business"
    >
      <template #head(new_member)>
        <div>最新報件</div>

        <div class="text-danger">(含首件回饋)</div>
      </template>

      <template #cell(number)="row">
        <span class="link" @click="businessOrganizationTree(row.item.number)">{{ row.item.number }}</span>
      </template>

      <template #cell(status)="row">
        <span v-if="row.item.status === 0">正常</span>
        <span v-else-if="row.item.status === 1">失效</span>
        <span v-else-if="row.item.status === 2">停權</span>
      </template>

      <!-- <template #cell(business)="row">
        <div>{{ row.item.name }}</div>

        <div>{{ row.item.cellphone }}</div>

        <div>{{ maskData(row.item.ID_number, 'ID') }}</div>

        <div>{{ convertRocDate(row.item.birthday) }}</div>
      </template> -->

      <template #cell(join_date)="row">
        {{ convertRocDate(row.item.join_date) }}
      </template>

      <template #cell(birthday)="row">
        {{ convertRocDate(row.item.birthday) }}
      </template>

      <template #cell(new_member_join_date)="row">
        {{ convertRocDate(row.item.new_member_join_date) }}
      </template>

      <template #cell(new_member)="row">
        <div class="nowrap">{{ row.item.new_member_number }}</div>

        <div class="nowrap">{{ row.item.new_member_name }}</div>

        <div class="nowrap">{{ convertRocDate(row.item.new_member_join_date) }}</div>
      </template>

      <template #cell(upper_number)="row">
        <div>{{ row.item.upper_number }}</div>

        <div>{{ row.item.upper_name }}</div>
      </template>

      <template #cell(valid_count)="row">
        <span
          :class="{'link': row.item.valid_count !== 0}"
          @click="row.item.valid_count !== 0 ? openContractModal(row.item) : null"
        >
          {{ row.item.valid_count }}
        </span>
      </template>

      <template #cell(print)="row">
        <div class="print">
          <b-button
            variant="secondary"
            size="sm"
            @click="generateBusinessCertificate(row.item)"
          >
            業務證
          </b-button>
        </div>
      </template>

      <template #cell(function)="row">
        <div class="function">
        <b-button
          variant="info"
          size="sm"
          v-auth="`update`"
          @click="openBusinessModal('edit', row.item)"
        >
            編輯
          </b-button>

          <b-button
            variant="danger"
            size="sm"
            v-auth="`update`"
            @click="deleteSales(row.item.id)"
          >
            刪除
          </b-button>

          <b-button
            v-if="row.item.status === 1"
            variant="warning"
            size="sm"
            v-auth="`update`"
            @click="openBusinessModal('copy', row.item)"
          >
            重報
          </b-button>

          <b-button
            variant="success"
            size="sm"
            @click="openThreePeriodModal(row.item)"
          >
            三期續繳總表
          </b-button>
        </div>
      </template>
    </tables-page>

    <!-- 業務modal -->
    <b-modal
      id="business-modal"
      ref="business-modal"
      title="業務"
      size="lg"
      centered
      hide-footer
      header-class="head-modal"
    >
      <b-form-group label-cols="4" label-cols-lg="2" label="業務編號" label-for="input-default">
        <b-form-input v-model="data.temp_table_data.number"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="姓名" label-for="input-default">
        <b-form-input v-model="data.temp_table_data.name"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="身分證字號" label-for="input-default">
        <b-form-input v-model="data.temp_table_data.ID_number"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="行動電話" label-for="input-default">
        <b-form-input v-model="data.temp_table_data.cellphone"></b-form-input>
      </b-form-group>

      <div class="text-center mt-4">
        <b-button
          class="mr-2"
          variant="success"
          size="sm"
          @click="sumit()"
        >
          確定
        </b-button>
        <b-button
          variant="danger"
          size="sm"
          class="mr-4"
          @click="$bvModal.hide('business-modal')"
        >
          取消
        </b-button>
      </div>
    </b-modal>

    <!-- 業務新增或編輯 modal -->
    <business-add-edit-modal
      v-model="status.businessAddEditModal"
      :data="data.temp_table_data"
      :isNew="status.isNew"
      @sumit="businessAddEdit" />

    <!-- 直推三期續繳總表 modal -->
    <three-period-bill-modal
      v-model="status.threePeriodBillModal"
      :data="data.temp_table_data" />

    <html-to-pdf
      v-if="status.resetDom"
      ref="htmlToPdf"
      @handlerCompleted="pdfCompleted"
    >
      <template slot="pdf-content">
        <business-certificate :data="data.temp_table_data"></business-certificate>
      </template>
    </html-to-pdf>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import businessApi from "@/models/API/businessApi";
import BusinessAddEditModal from"./components/modal/BusinessAddEditModal";
import ThreePeriodBillModal from "@/components/common/Modal/ThreePeriodBillModal";
import { convertRocDate, downloadFile, getTodayDate, getFirstAndLastDayOfMonth, maskData } from "@/models/HELPERS/common.js";
import HtmlToPdf from '@/components/common/HtmlToPdf';
import BusinessCertificate from '@/components/common/PrintTemplate/BusinessCertificate';

export default {
  name: 'business',
  components: {
    BreadCrumb,
    TablesPage,
    BusinessAddEditModal,
    ThreePeriodBillModal,
    HtmlToPdf,
    BusinessCertificate
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '業務管理', url: '', isActive: true },
          { name: '業務', url: '', isActive: false }
        ]
      },
      options: {
        status: [
          { value: '', text: '全部' },
          { value: 0, text: '正常' },
          { value: 1, text: '失效' },
          { value: 2, text: '停權' },
        ],
      },
      search: {
        status: '',
        number: '',
        name: '',
        blur: ''
      },
      status: {
        isNew: false,
        businessAddEditModal: false,
        threePeriodBillModal: false,
        resetDom: false
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "number",
            label: "編號",
            sortable: true
          },
          {
            key: "status",
            label: "權益"
          },
          // {
          //   key: "business",
          //   label: "業務",
          //   sortable: true
          // },
          {
            key: "name",
            label: "業務姓名",
            sortable: true
          },
          {
            key: "cellphone",
            label: "手機",
            sortable: true
          },
          {
            key: "ID_number",
            label: "身分證",
            sortable: true
          },
          {
            key: "birthday",
            label: "生日",
            sortable: true
          },
          {
            key: "rank",
            label: "目前聘階",
            sortable: true
          },
          {
            key: "join_date",
            label: "報聘日期",
            sortable: true
          },
          {
            key: "new_member",
            label: "最新報件"
          },
          // {
          //   key: "new_member_name",
          //   label: "最新報件要助人"
          // },
          // {
          //   key: "new_member_join_date",
          //   label: "最新報件日"
          // },
          // {
          //   key: "upper_number",
          //   label: "推薦人編號"
          // },
          {
            key: "valid_count",
            label: "直推契約"
          },
          {
            key: "return_member_number",
            label: "首件回饋"
          },
          {
            key: "upper_number",
            label: "推薦人",
            sortable: true
          },
          {
            key: "remark",
            label: "註記"
          },
          {
            key: "print",
            label: "列印"
          },
          {
            key: "function",
            label: "功能"
          }
        ],
        table_sort: {
          sortBy: '',
          sort: ''
        },
        page: {},
        temp_table_data: {},
      }
    }
  },
  mounted() {
    this.businessApi = new businessApi();
    this.load();
  },
  methods: {
    convertRocDate,
    maskData,
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.businessApi.page);
      this.getSales();
    },
    // 開啟業務編輯modal
    openBusinessModal(type = 'new', item = null) {
      this.status.isNew = type === 'new' || type === 'copy' ? true : false;
      this.status.businessAddEditModal = true;

      this.data.temp_table_data = Object.assign({}, item);

      if (type === 'new') {
        this.data.temp_table_data.type = 2;
      } else if (type === 'edit') {

      } else if (type === 'copy') {
        this.data.temp_table_data.status = 0;
        this.data.temp_table_data.type = item.type ? item.type : 2;
        this.data.temp_table_data.join_date = '';
        this.data.temp_table_data.first_return_plan = '';
        this.data.temp_table_data.upper_id = '';
        this.data.temp_table_data.upper_number = '';
        this.data.temp_table_data.upper_name = '';
        this.data.temp_table_data.return_member_id = '';
        this.data.temp_table_data.return_member_number = '';
        this.data.temp_table_data.return_member_name = '';
        this.data.temp_table_data.return_member_ID_number = '';
        this.data.temp_table_data.return_member_join_date = '';
        this.data.temp_table_data.join_check = 0;
        this.data.temp_table_data.join_amount = 0;
        this.data.temp_table_data.join_payment_source = null;
        this.data.temp_table_data.join_payment_at = '';
        this.data.temp_table_data.join_invoice = '';
        this.data.temp_table_data.join_bank_name = '';
        this.data.temp_table_data.join_remark = '';
      }
    },
    // 開啟直推三期續繳總表modal
    openThreePeriodModal(item = null) {
      this.status.threePeriodBillModal = true;

      const params = {
        class_detail: 1,
        sales_name: item.name,
        sales_number: item.number,
        member_status: 0,
        dead_date_S: this.getDateRange(false).date_start,
        dead_date_E: this.getDateRange(false).date_end
      };

      this.data.temp_table_data = Object.assign({}, params);
    },
    // 取得日期範圍
    getDateRange(is_special_mode = true) {
      const [year, month, day] = getTodayDate().split('-').map(Number);
      const today_start = new Date(), today_end = new Date();

      let date_start, date_end;

      // 如現在是8月，則日期為10號以前，顯示567月;反之顯示678月
      if (day <= 10 && is_special_mode) {
        today_start.setMonth(today_start.getMonth() - 3)
        date_start = getFirstAndLastDayOfMonth(today_start).first_day;

        today_end.setMonth(today_end.getMonth())
        date_end = getFirstAndLastDayOfMonth(today_end).first_day;
      } else {
        today_start.setMonth(today_start.getMonth() - 2)
        date_start = getFirstAndLastDayOfMonth(today_start).first_day;

        today_end.setMonth(today_end.getMonth() + 1)
        date_end = getFirstAndLastDayOfMonth(today_end).first_day;
      }

      return { date_start, date_end };
    },
    // 查詢業務
    getSales(pageIndex = null, sortBy = '', sort = '') {
      if (sortBy) this.data.table_sort.sortBy = sortBy;
      if (sort) this.data.table_sort.sort = sort;

      const params = {
        ...this.search,
        'sortBy': this.data.table_sort.sortBy,
        'sort': this.data.table_sort.sort,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };
      this.businessApi.getSales((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數
        this.data.table_data = res.data;
      }, params)
    },
    // 新增業務 || 更新業務
    sumit () {
      const required =
        ['number',
        'name',
        'ID_number'];
      const status = required.every(item => this.data.temp_table_data[item] != null && this.data.temp_table_data[item] !== '');

      if (!status) {
        const result = { message: '欄位請填寫完整', title: '業務' };
        this.businessApi.toast(() => {}, result, false);

        return;
      }

      const fun = this.status.isNew ? 'addSales' : 'updateSales';
      this.businessApi[fun]((response) => {
        const res = response.data;

        if (res.code === 0) this.getSales();

          this.$root.$emit('bv::hide::modal', 'business-modal');
      }, this.data.temp_table_data)
    },
    // 刪除業務
    deleteSales(id) {
      const r = confirm("確定刪除業務？");

      if (r) {
        this.businessApi.deleteSales((response) => {
          const res = response.data;

          if (res.code === 0) this.getSales();
        }, id)

        return true;
      }
      return false;
    },
    // 新增 || 更新業務
    businessAddEdit() {
      const fun = this.status.isNew ? 'addSales' : 'updateSales';
      const status_text = this.status.isNew ? '新增' : '更新';

      this.businessApi[fun]((response) => {
        const res = response.data;
        let result = {};

        if (res.code === 0) {
          result = { message: `${status_text}成功`, title: '業務' };

          this.getSales();
          this.status.businessAddEditModal = false;
        } else if (res.code === 1) {
          result = { message: res.msg, title: '業務' };
        }

        this.businessApi.toast(() => {}, result, res.code === 0);
      }, this.data.temp_table_data)
    },
    // 匯出業務EXCEL
    exportSales() {
      this.businessApi.exportSales((response) => {
        if (!response) return;

        downloadFile(response);
      }, this.search)
    },
    // 重置欄位，並搜尋
    resetSearch() {
      this.search = {
        status: '',
        number: '',
        name: '',
        blur: ''
      }

      this.getSales(1);
    },
    // 產生業務證
    async generateBusinessCertificate(item = {}) {
      this.status.resetDom = true;

      this.data.temp_table_data = Object.assign({}, item);

      await this.$nextTick(); // 等待當前更新週期結束

      this.$refs.htmlToPdf.generatePdf();
    },
    // PDF產生完成
    pdfCompleted () {
      this.$set(this.status, 'resetDom', false);
      this.$forceUpdate();
    },
    // 查詢業務上層組織樹
    businessOrganizationTree(number) {
      const params = {
        number: number,
      }

      sessionStorage.setItem("businessNumber", JSON.stringify(params));

      this.$router.push('/backstage/yf/businessOrganizationTree');
    },
    // 開啟契約 modal
    openContractModal(item = null) {
      const routeUrl = this.$router.resolve(
        {
          path: '/backstage/yf/contract',
          query: {
            'sales_number': item.number,
            'status': 0
          }
        });

      window.open(routeUrl.href, '_blank');
    },
    // 重新載入業務聘階
    refreshRank() {
      const r = confirm("確定重新載入業務聘階？");

      if (r) {
        this.businessApi.refreshRank((response) => {
          const res = response.data;
          let result = {};

          if (res.code === 0) {
            result = { message: `重新載入業務聘階成功`, title: '業務' };
          } else if (res.code === 1) {
            result = { message: `重新載入業務聘階失敗`, title: '業務' };
          }

          this.businessApi.toast(() => {}, result, res.code === 0);
        })

        return true;
      }
      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-basis: 80%;
    .blur {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 10px;
      .blur-info {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        font-size: 12px;
        background: #17A2B8;
        color: #FFF;
      }
    }
  }
  .btn-area {
    flex-basis: 20%;
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
    }
  }
}

.table-page {
  /deep/ table {
    thead {
      tr {
        th {
          // white-space: nowrap;
        }
      }
    }
    tbody {
      tr {
        td {
          // white-space: nowrap;
          // .print {
          //   display: grid;
          //   grid-template-columns: repeat(2, 1fr);
          //   gap: 10px;
          // }
          .nowrap {
            white-space: nowrap;
          }
          .function {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 0.5rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/business.vue